import { type ComponentProps, type JSX } from "react";

import { RatesTab } from "./RatesTab";

type StructureEditorSectionProps = ComponentProps<typeof RatesTab> & {
  /** Hidden on the current plan, whose rate structure is set on the Build tab. */
  visible: boolean;
};

/**
 * Wraps the rate-structure editor so the current-plan drawer can omit it
 * without adding a branch to the drawer's render.
 */
export const StructureEditorSection = ({
  visible,
  ...ratesTabProps
}: StructureEditorSectionProps): JSX.Element | null =>
  visible ? <RatesTab {...ratesTabProps} /> : null;
